// extracted by mini-css-extract-plugin
export default {"interactiveBorderEdit":"FormElement_interactiveBorderEdit__WuskE"};